import { render, staticRenderFns } from "./Navegador.vue?vue&type=template&id=5f17c612&"
import script from "./Navegador.vue?vue&type=script&lang=js&"
export * from "./Navegador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports